"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataState = void 0;
const React = __importStar(require("react"));
const LifecyclePageHighchartsOptionsProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/state/data/LifecyclePageHighchartsOptionsProvider");
const antd_1 = require("antd");
const LifecyclePopover_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/common/help/LifecyclePopover");
const LifecycleExportHighchartsButton_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/state/data/LifecycleExportHighchartsButton");
const PageContent_1 = __importDefault(require("src/hello_assets/src/components/ui/common/content/PageContent"));
const LifecycleChartsSettingsComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/state/data/highchartsSettings/LifecycleChartsSettingsComponent");
const LifecycleHighchartsComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/state/data/LifecycleHighchartsComponent");
const LifecycleFormComponent_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/state/data/form/LifecycleFormComponent");
const react_router_dom_1 = require("react-router-dom");
const LifecyclePageDataProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/LifecyclePageDataProvider");
const LifecyclePageModelProvider_1 = require("src/hello_assets/src/components/ui/loggedin/content/project/withData/features/lifecycle/LifecyclePageModelProvider");
const DataState = () => {
    return React.createElement(React.Fragment, null,
        React.createElement(LifecyclePageHighchartsOptionsProvider_1.LifecyclePageHighchartsOptionsProvider, null,
            React.createElement(antd_1.PageHeader, { title: React.createElement(antd_1.Space, null,
                    React.createElement(React.Fragment, null, "Lifecycle"),
                    React.createElement(LifecyclePopover_1.LifecyclePopover, null)), extra: React.createElement(antd_1.Space, null,
                    React.createElement(LifecycleExportHighchartsButton_1.LifecycleExportHighchartsButton, null)) }),
            React.createElement(PageContent_1.default, null,
                React.createElement(PageContent_1.default.Card, null,
                    React.createElement(LifecycleChartsSettingsComponent_1.LifecycleChartSettingsComponent, null),
                    React.createElement(LifecycleHighchartsComponent_1.LifecycleHighchartsComponent, null)),
                React.createElement(PageContent_1.default.CardSpacer, null),
                React.createElement(PageContent_1.default.Card, null,
                    React.createElement(antd_1.Row, null,
                        React.createElement(antd_1.Col, { span: 24 },
                            React.createElement(LifecycleFormComponent_1.LifecycleFormComponent, null)))))),
        process.env.NODE_ENV === "development" ? React.createElement(DebugView, null) : null);
};
exports.DataState = DataState;
const DebugView = () => {
    const lifecyclePageDataContext = (0, LifecyclePageDataProvider_1.useLifecyclePageDataContext)();
    const lifecyclePageModelContext = (0, LifecyclePageModelProvider_1.useLifecyclePageModelContext)();
    const location = (0, react_router_dom_1.useLocation)();
    return React.createElement(React.Fragment, null,
        React.createElement(PageContent_1.default.CardSpacer, null),
        React.createElement(PageContent_1.default.Card, null,
            React.createElement(antd_1.Row, { gutter: [16, 16] },
                React.createElement(antd_1.Col, { span: 24 },
                    "location:",
                    React.createElement("br", null),
                    React.createElement("span", { style: { fontSize: "10px", maxHeight: 180, wordBreak: "break-all" } }, decodeURI(location.search))),
                React.createElement(antd_1.Col, { span: 8 },
                    "pageModelFormState:",
                    React.createElement("br", null),
                    React.createElement("pre", { style: { fontSize: "10px", maxHeight: 250 } }, JSON.stringify(lifecyclePageModelContext.pageModelFormState, null, 4))),
                React.createElement(antd_1.Col, { span: 8 },
                    "dataURLState:",
                    React.createElement("br", null),
                    React.createElement("pre", { style: { fontSize: "10px", maxHeight: 250 } }, JSON.stringify(lifecyclePageDataContext.urlState, null, 4))),
                React.createElement(antd_1.Col, { span: 8 },
                    "dataState:",
                    React.createElement("br", null),
                    React.createElement("pre", { style: { fontSize: "10px", maxHeight: 250 } }, JSON.stringify(lifecyclePageDataContext.state, null, 4)))),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null),
            React.createElement("br", null)));
};
